



































import {
    Component,
    Vue,
    Prop
} from 'vue-property-decorator';
import {
    MessageBox
} from 'mint-ui';
// 声明组件*****************
@Component
export default class DeviceMessage extends Vue {
    // 属性*****************

    // 参数*****************
    // props
    @Prop({
        default: () => ({})
    }, Object)
    private data!: object;

    @Prop({
        default: () => true
    }, Object)
    private touch!: boolean;

    // 方法*****************
    // 删除
    private deleteMessage(): void {
        MessageBox.confirm('是否删除?', '').then(action => {
            console.log('888')
        }).catch(error => {
            console.log(error)
        })
    }

    // 计算属性
    get statusType(): string {
        switch (this.data['type']) {
            case 'RED':
                return 'status-red';
            case 'BLUE':
                return 'status-blue'
            case 'GREEN':
                return 'status-green'
            case 'YELLOW':
                return 'status-yellow'
            case 'DEFAULT':
                return ''
            default:
                return ''
        }
    }
}
